import {React, useState} from 'react'
import { useHistory } from 'react-router-dom'

import ControlPanelSolutions from '../../assets/IAGeneric/ControlPanelSolutions.png'
import IndustrialComputing from '../../assets/IAGeneric/IndustrialComputing.png'
import MachineSafety from '../../assets/IAGeneric/MachineSafety.png'
import MotionControls from '../../assets/IAGeneric/MotionControls.png'
import Networking from '../../assets/IAGeneric/Networking.png'
import OperatorInterface from '../../assets/IAGeneric/OperatorInterface.png'
import PowerMonitoring from '../../assets/IAGeneric/PowerMonitoring.png'
import Sensors from '../../assets/IAGeneric/Sensors.png'
import Cybersecurity from '../../assets/IAGeneric/Cybersecurity.png'
import Pneumatics from '../../assets/IAGeneric/Pneumatics.png'
import IIotSolutions from '../../assets/IAGeneric/IIotSolutions.png'
import Drives from '../../assets/IAGeneric/Drives.png'

import IAHome from '../../assets/home-icon.svg'

import content from '../content.json'

import CPSMenu from '../CPSMenu/CPSMenu'


import './SolutionInformation.scss'

import Arrow from '../../assets/IAGeneric/Arrow.png'
import { IAVisual } from '../IAVisual/IAVisual'

function SolutionInformation () {
    let history = useHistory()

    const [active, setActive] = useState('ENCLOSURES')

    const [imageLoaded, setImageLoaded] = useState(false);

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
  
    let rightOpen = 'open'

    const applicationSolutionImage = window.location.pathname.split('/')[3]// window.location.pathname .split['/'] break up the pathname

    // Three values in list include: Solution name, Image, Solution web link
    // images[applicationSolutionImage][2] = SHOP NOW link of that category (eg: https://www.graybar.com/)
    const images = {
        "ControlPanelSolutions": ["Control Panel Solutions", ControlPanelSolutions, ''],
        "IndustrialComputing": ["Industrial Computing", IndustrialComputing, ''],
        "MachineSafety": ["Machine Safety", MachineSafety, ''],
        "MotionControls": ["Motion Controls", MotionControls, ''],
        "Networking": ["Networking", Networking, ''],
        "OperatorInterface": ["Operator Interface", OperatorInterface, ''],
        "PowerMonitoring": ["Power Monitoring", PowerMonitoring, ''],
        "Sensors": ["Sensors", Sensors, ''],
        "Cybersecurity": ["Cybersecurity", Cybersecurity, ''],
        "Pneumatics": ["Pneumatics", Pneumatics, ''],
        "IIotSolutions": ["IIotSolutions", IIotSolutions, ''],
        "Drives": ["Drives", Drives, '']
    }
    
    // Key -> image name, Value -> image link 
    var image;
    if (applicationSolutionImage === "ControlPanelSolutions") {
        image = content[applicationSolutionImage]?.media?.[active]
    } else {
        image = content[applicationSolutionImage]?.media
    }
    const solutionImages = Object.keys(image) // return keys

    return (
    <div id='solution-layout'>
        <div id='solution-main'>
            <div className='solution-header'>
                <h3 className={`
                    solution-title
                    ${'right-' + rightOpen}
                `}>
                </h3>
            </div>
                <div className='overview-main-content'> 
                    <IAVisual />
                </div>
        </div>

        {applicationSolutionImage === "ControlPanelSolutions" ? (
            <div style={{display:'flex', flexDirection: 'row', paddingTop: '1%'}}>
                <CPSMenu 
                    labels={['ENCLOSURES', 'VARIABLE FREQUENCY DRIVES', 'PLC CONTROL', 'POWER & CONTROL']} 
                    active={active} setActive={setActive} 
                />
            </div>
        ) : (
            <div />
        )}

        <div id='right' className={rightOpen} >
            <img
                alt="IA Home Icon"
                className="home-icon"
                src={IAHome}

                onClick={ () => history.push('/ia-graphic')}
            />
                <div className={`solution-sidebar ${rightOpen}`} >
                    <div className='solution-header'>
                    </div>
                    <div className='solution-sidebar-content'>
                        <p>
                            <div className="sidebarContainer">
                                <div className="sidebarList">
                                    {solutionImages?.map((item, index) => {
                                        return(
                                        <div className='cardImages' key={item}>
                                            <div className="sidebarCard" >

                                         <table>
                                            <tr>
                                              <td>
                                                    <img
                                                        alt="IA graphic"
                                                        className="solution-md-image"
                                                        src={image[item][0]}
                                                        onClick={ 
                                                            () => image[item][1] !== "" ? window.open(image[item][1],"_self"): "" 
                                                        }
                                                    /> 
                                                    </td>
                                                <td>
                                                    <div className='overlay'>
                                                    <img
                                                    alt ='arrow image'
                                                    className = 'Arrow'
                                                    src ={Arrow}
                                                    onClick={ 
                                                        () => image[item][1] !== "" ? window.open(image[item][1],"_self"): "" 
                                                    }
                                                    />
                                                    </div>
                                                    </td>
                                                  </tr>

                                            </table>   

                                            </div>
                                            <p style={{color:'white', fontSize:'medium', margin:'0px 0px 20px 5px'}}>{item}</p>
                                        </div>)
                                    })
                                    }
                                </div>
                            </div>
                        </p>
                    </div>
                </div>
            {/* </div> */}
        </div>

    </div>
    );
}

export default SolutionInformation

